import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "We manage the servers and networks your business runs on — configuration, hardening, monitoring and maintenance — so your systems stay secure, patched and available.",
    "From routine administration to incident response, our team acts as an extension of yours, keeping the lights on while you focus on the business.",
];

const FEATURES = [
    { title: "Proactive maintenance", text: "Patching, backups and health checks that prevent problems before they hit." },
    { title: "Security hardening", text: "Configuration and access controls that reduce risk across the stack." },
    { title: "Monitoring & alerts", text: "Continuous visibility so issues are caught early, not after an outage." },
    { title: "Responsive support", text: "A team on hand to resolve incidents quickly when they do arise." },
];

const CHECKS = [
    "Server configuration & hardening",
    "Network administration",
    "Backup & recovery",
    "Monitoring & alerting",
    "Patch management",
];

export default function ServerAndNetworkingAdministration() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Server & Networking Administration" eyebrowAs="span">
                    Keep infrastructure healthy, secure and available — proactive server and network administration by an experienced team.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
